import {baseUrl, buildAuthRequest, handleJsonResponse} from "./util/Common";

function findRunners() {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/runners`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function findRunnerById(runnerId) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/runners/${runnerId}`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

export {
    findRunners,
    findRunnerById,
}